module.exports = __webpack_public_path__ + "a8832d8cea19f4d42807ad0d7423d89d.MP3";